<template>
	<div
		class="c-Loader"
		:class="loaderClassObj"
		:style="loaderStyleObj">
		<svg class="c-Loader__spinner" width="34" height="34" version="1" xmlns="http://www.w3.org/2000/svg">
			<g transform="translate(2 2)" stroke-width="4" fill="none" fill-rule="evenodd">
				<circle class="c-Loader__spinnerTrack" cx="15" cy="15" r="15"/>
				<path class="c-Loader__spinnerProgress" d="M15 0a15 15 0 1 0 15 15" stroke-linecap="round"/>
			</g>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'Loader',
	props: {
		/**
     * If the Loader is active
     * @values true, false
     */
		active: {
			type: Boolean,
			required: false,
			default: false
		},
		/**
     * If the Loader is global
     * @values true, false
     */
		isGlobal: {
			type: Boolean,
			required: false,
			default: true
		},
		/**
     * The Loader size
     */
		size: {
			type: Number,
			required: false,
			default: 34
		}
	},
	computed: {
		loaderClassObj () {
			return {
				'is-active': this.active,
				'is-global': this.isGlobal
			}
		},
		loaderStyleObj () {
			if (this.size === 34) {
				return {}
			}
			const scaleFactor = this.size / 34
			return {
				transform: `scale3d(${scaleFactor}, ${scaleFactor}, ${scaleFactor})`
			}
		}
	}
}
</script>

<style lang="scss" scoped>
@import '../../scss/variables.scss';

.c-Loader {
  display: none;
  align-items: center;
  justify-content: center;

  &.is-active {
    display: flex;
  }

  &.is-global {
    z-index: 10000;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba($color: $un-white, $alpha: 0.5);
  }

  &__spinner {
    width: 34px;
    height: 34px;
    animation: spin 1.5s ease infinite;

    .c-Loader__spinnerTrack {
      stroke: $un-gray1;
    }

    .c-Loader__spinnerProgress {
      stroke: $un-blue;
    }
  }
}

@keyframes spin {
  100% {
    transform:rotate(360deg);
  }
}
</style>
